import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSalonPublicTheme } from '../../../../context/SalonPublicThemeContext';


const ABOUT_VARIANTS = new Set(['saloone', 'editorial', 'compact', 'panel']);

const SalonTemplateAbout = ({
  data,
  variant = 'saloone',
  visible = true,
}) => {
  const { t } = useTranslation();
  const { tokens: theme } = useSalonPublicTheme();
  const description = typeof data === 'string' ? data : data?.description;
  const aboutVariant = ABOUT_VARIANTS.has(variant) ? variant : 'saloone';

  if (!visible || !description) return null;

  return (
    <Box
      data-salon-template-block="about"
      data-variant={aboutVariant}
      sx={{
        backgroundColor: theme.colors.background.primary,
        borderRadius: 4,
        border: `1px solid ${theme.colors.border.light}`,
        p: 3,
        mb: 3,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Typography component="h2" sx={{ fontWeight: 700, color: theme.colors.gray[700], mb: 1 }}>
        {t('landing_salon_details.about')}
      </Typography>
      <Typography sx={{ color: theme.colors.gray[600], lineHeight: 1.7, whiteSpace: 'pre-line' }}>
        {description}
      </Typography>
    </Box>
  );
};

export default SalonTemplateAbout;
